<template>
  <ul>
    <!-- <li>
     
    <h3  style="margin-left:1em"> <date-time-widget  /></h3> 
      </li> -->
    <component
      v-for="item in items"
      :is="resolveNavItemComponent(item)"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import  DateTimeWidget   from '@/views/widgets/DateTimeWidget.vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    DateTimeWidget
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  setup(props) {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent
    }
  },
}
</script>
